var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5625C5.94922 1.5625 4.08984 2.65625 3.05078 4.40625C2.03906 6.18359 2.03906 8.34375 3.05078 10.0938C4.08984 11.8711 5.94922 12.9375 8 12.9375C10.0234 12.9375 11.8828 11.8711 12.9219 10.0938C13.9336 8.34375 13.9336 6.18359 12.9219 4.40625C11.8828 2.65625 10.0234 1.5625 8 1.5625ZM8 14.25C5.48438 14.25 3.1875 12.9375 1.92969 10.75C0.671875 8.58984 0.671875 5.9375 1.92969 3.75C3.1875 1.58984 5.48438 0.25 8 0.25C10.4883 0.25 12.7852 1.58984 14.043 3.75C15.3008 5.9375 15.3008 8.58984 14.043 10.75C12.7852 12.9375 10.4883 14.25 8 14.25ZM6.90625 9.4375H7.5625V7.6875H6.90625C6.52344 7.6875 6.25 7.41406 6.25 7.03125C6.25 6.67578 6.52344 6.375 6.90625 6.375H8.21875C8.57422 6.375 8.875 6.67578 8.875 7.03125V9.4375H9.09375C9.44922 9.4375 9.75 9.73828 9.75 10.0938C9.75 10.4766 9.44922 10.75 9.09375 10.75H6.90625C6.52344 10.75 6.25 10.4766 6.25 10.0938C6.25 9.73828 6.52344 9.4375 6.90625 9.4375ZM8 5.5C7.50781 5.5 7.125 5.11719 7.125 4.625C7.125 4.16016 7.50781 3.75 8 3.75C8.46484 3.75 8.875 4.16016 8.875 4.625C8.875 5.11719 8.46484 5.5 8 5.5Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleWhite);
export default __webpack_public_path__ + "static/media/info-circle-white.7ccc04872c9605c98f128752599a0e41.svg";
export { ForwardRef as ReactComponent };